import { alpha, type Theme } from '@mui/material/styles';

// `color` : clé de palette ('primary.main', 'text.secondary'…) ou couleur CSS
const resolveColor = (theme: Theme, color: string): string => {
  const value = color.split('.').reduce<unknown>((acc, key) => (acc as Record<string, unknown> | undefined)?.[key], theme.palette);
  return typeof value === 'string' ? value : color;
};

export const filledButtonSx = (color = 'primary.main') => ({
  textTransform: 'none' as const,
  fontWeight: 500,
  fontSize: '0.82rem',
  backgroundColor: color,
  color: 'common.white',
  borderRadius: 1.5,
  '&:hover': { backgroundColor: color, opacity: 0.88 },
});

export const outlinedButtonSx = (color = 'primary.main') => ({
  textTransform: 'none' as const,
  fontWeight: 500,
  fontSize: '0.82rem',
  borderColor: color,
  color,
  borderRadius: 1.5,
  '&:hover': { borderColor: color, backgroundColor: (theme: Theme) => alpha(resolveColor(theme, color), 0.06) },
});

export const toolbarSx = {
  display: 'flex',
  gap: 1,
  flexWrap: 'wrap',
  alignItems: 'center',
  p: 1.5,
  border: '1px solid',
  borderColor: 'grey.200',
  borderRadius: 2,
  backgroundColor: 'grey.50',
};

export const cardSx = {
  border: '1px solid',
  borderColor: 'grey.200',
  borderRadius: 2,
  p: 2.5,
  mb: 2.5,
  backgroundColor: 'background.paper',
};

export const sectionTitleSx = (color = 'primary.main') => ({
  fontWeight: 700,
  color,
  letterSpacing: 0.3,
  fontSize: '0.88rem',
  textTransform: 'uppercase' as const,
});
